import { styled } from "@mui/material"
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import { MainContent } from "../MainContent"
import { Container } from "../Settings/shared/SettingsContainer"

import { extraColors, theme } from "../../utils/theme"
import vectorJson from "./vector_swagger.json"

const SwaggerPlacementContainer = styled("div")({
  alignSelf: "center",
  display: "flex",
  marginTop: -40,
  ".information-container": {
    marginBottom: -40,
  },
  ".scheme-container, .try-out": {
    display: "none",
  },
  ".swagger-ui": {
    [theme.breakpoints.up("sm")]: {
      top: 0,
      minWidth: 600,
    },
    justifyContent: "center",
    "&, h1, h2, h3, h4, h5, h6, p, li, td, th, code, pre, span, label": {
      color: extraColors.white,
    },
    a: {
      color: theme.palette.primary.light,
    },
    ".info .title, .models .title, .opblock-tag": {
      color: extraColors.white,
    },
    ".opblock-summary-description": {
      color: extraColors.hint,
    },
    select: {
      background: extraColors.dark5,
      color: extraColors.white,
      WebkitAppearance: "none",
      MozAppearance: "none",
      appearance: "none",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8" fill="white" stroke="white"><path d="M1.41 0L6 4.58 10.59 0 12 1.41l-6 6-6-6z"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px center",
      backgroundSize: "12px 8px",
      paddingRight: 28,
      "&::-ms-expand": {
        display: "none",
      },
    },
    ".json-schema-2020-12-head, .json-schema-2020-12-head *": {
      background: "transparent",
      backgroundColor: "transparent",
      color: extraColors.white,
      ".opblock-summary-description, .json-schema-2020-12-expand-deep-button": {
        color: extraColors.hint,
      },
    },
    ".opblock .opblock-section-header, .opblock .opblock-section-header *": {
      background: "transparent",
      backgroundColor: "transparent",
      color: extraColors.white,
      ".opblock-description-wrapper": {
        color: extraColors.white,
      },
    },
    ".example__section-header": {
      color: extraColors.white,
    },
    ".json-schema-2020-12-json-viewer, .json-schema-2020-12-json-viewer *": {
      background: "transparent",
      backgroundColor: "transparent",
      color: extraColors.white,
      ".json-schema-2020-12-expand-deep-button": {
        color: extraColors.hint,
      },
    },
    ".json-schema-2020-12-body *": {
      background: "transparent",
      backgroundColor: "transparent",
      ".json-schema-2020-12-expand-deep-button": {
        color: extraColors.hint,
      },
    },
    "svg, svg *": {
      fill: extraColors.hint,
      stroke: extraColors.hint,
    },
  },
})

const SwaggerUIStyled = styled(SwaggerUI)({
  minWidth: 600,
})

export const VectorDocumentation = () => {
  return (
    <MainContent
      headerProps={{
        title: "Vector API Documentation",
      }}
    >
      <Container
        sx={{
          display: "flex",

          justifyContent: "center",
          width: "fit-content",
          justifySelf: "center",
        }}
      >
        <SwaggerPlacementContainer>
          <SwaggerUIStyled spec={vectorJson} url={undefined} />
        </SwaggerPlacementContainer>
      </Container>
    </MainContent>
  )
}
